module.exports = __webpack_public_path__ + "img/settings icon.ded99eda.png";